import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  barContainer: {
    position: 'relative',
    background: '#EBECF4',
    borderRadius: '5px',
    width: '100%',
    display: 'inline-flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    fontFamily: 'Roboto',
    fontSize: '14px',
    justifyContent: 'space-between',
  },
  leftJustyfied: {
    justifyContent: 'flex-start',
  },
  span: {
    display: 'inline-flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    padding: '2px',
    paddingRight: '20px',
  },
  spanImage: {
    display: 'inline-block',
    flexWrap: 'nowrap',
    textAlign: 'center',
  },
  circle: {
    margin: '20px',
    borderRadius: '50%',
    minWidth: '40px',
    height: '40px',
    lineHeight: '40px',
    fontWeight: 550,
    fontSize: '12px',
    textAlign: 'center',
    color: 'white',
  },
  circleMagentaBackgroud: {
    backgroundColor: '#7B62D5',
  },
  circleBlueBackgroud: {
    backgroundColor: '#2B4CC5',
  },
  circleGreenBackgroud: {
    backgroundColor: '#347F42',
  },
  circlePinkBackgroud: {
    backgroundColor: '#EA2075',
  },
  circleContrastBackgroud: {
    border: '1px white solid',
  },
  arrow: {
    display: 'block',
    margin: '12px',
    marginTop: '40px',
  },
  text: {
    fontWeight: 500,
    textAlign: 'left',
  },
  subText: {
    fontWeight: 800,
    textAlign: 'left',
    margin: '10px 0px 10px 0px',
  },
  textArea: {
    marginTop: '24px',
    marginLeft: '-6px',
  },
}));
